import { render, staticRenderFns } from "./traineeMaterialsApproval.vue?vue&type=template&id=44009bb0&scoped=true"
import script from "./traineeMaterialsApproval.vue?vue&type=script&lang=js"
export * from "./traineeMaterialsApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44009bb0",
  null
  
)

export default component.exports